/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-19 16:01:57 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-27 10:13:17
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" />
    <div class="docs">
      <h1>{{ st('helpDocs.howToJoinBrand.h1') }}</h1>

      <h2>{{ st('helpDocs.howToJoinBrand.h2Req') }}</h2>
      <p>{{ st('helpDocs.howToJoinBrand.pReqIntro') }}</p>
      <ul>
        <li class="fw500">{{ st('helpDocs.howToJoinBrand.liReq1') }}</li>
        <li class="fw500">{{ st('helpDocs.howToJoinBrand.liReq2') }}</li>
      </ul>

      <h2>{{ st('helpDocs.howToJoinBrand.h2Register') }}</h2>

      <ul>
        <li class="fw500">{{ st('helpDocs.howToJoinBrand.liReg1') }}</li>
        <li class="fw500">{{ st('helpDocs.howToJoinBrand.liReg2') }}</li>
      </ul>
      <h2>{{ st('helpDocs.howToJoinBrand.h2Connect') }}</h2>
      <ul>
        <li class="fw500">{{ st('helpDocs.howToJoinBrand.liConn1') }}</li>
        <li class="fw500">{{ st('helpDocs.howToJoinBrand.liConn2') }}</li>
      </ul>
      <h2>{{ st('helpDocs.howToJoinBrand.h2Activate') }}</h2>
      <ul>
        <li class="fw500">{{ st('helpDocs.howToJoinBrand.liAct1') }}</li>
        <li class="fw500">{{ st('helpDocs.howToJoinBrand.liAct2') }}</li>
        <li class="fw500">{{ st('helpDocs.howToJoinBrand.liAct3') }}</li>
      </ul>
      <p>{{ st('helpDocs.howToJoinBrand.pTips') }}</p>
      <ul>
        <li class="fw500">{{ st('helpDocs.howToJoinBrand.liTip1') }}</li>
        <li class="fw500">{{ st('helpDocs.howToJoinBrand.liTip2') }}</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
</script>
